import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import { UiKit } from 'components';
import { If } from 'utils';
import { ReactComponent as X } from 'assets/img/icons/cross.svg';
import { useModal } from '../context.js';
import Title from 'components/UiKit/Title';
import Caption from 'components/UiKit/Caption';

/**
 * @param {Object} props
 * @param {title} props.title
 * @param {title} props.subTitle
 * @param {import('utils/types').SizeVariant} props.titleSize
 * @param {import('utils/types').Weight} props.titleWeight
 * @param {boolean} props.hideCrossBtn
 * @param {string} props.className
 * @param {string} props.contentClassName
 * @param {string} props.titleClassName
 * @param {string} props.subTitleClassName
 * @param {React.ReactNode} props.children
 */
export default function ModalHeader({
  title = '',
  subTitle = '',
  titleSize = 'sm',
  titleWeight = 'normal',
  hideCrossBtn = false,
  className = '',
  contentClassName = '',
  titleClassName = '',
  subTitleClassName = '',
  children = null
}) {
  const { isProcessing, onClose } = useModal();

  return (
    <div className={cn(styles.container, className)}>
      <div className={styles.header}>
        <div className={cn(styles.content, contentClassName)}>
          <Title
            size={titleSize}
            weight={titleWeight}
            className={titleClassName}
          >
            {title}
          </Title>
          {children}
        </div>
        <If test={!hideCrossBtn}>
          <UiKit.Button
            variant="ghost"
            onClick={onClose}
            disabled={isProcessing}
            className={styles.button}
          >
            <X width={16} height={16} />
          </UiKit.Button>
        </If>
      </div>
      <Caption className={subTitleClassName}>{subTitle}</Caption>
    </div>
  );
}
